import {
  DeclinedReason,
  DeclinedReasonService,
  ListSalesOrderRequestFilters,
  OrderInterface,
  SalesOrdersService as SalesOrdersApiService,
  Status,
} from '@vendasta/sales-orders';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay, take } from 'rxjs/operators';

// There is no state for this service, so it can be provided in root instead of being provided by the automation component
@Injectable({ providedIn: 'root' })
export class SalesOrdersService {
  constructor(
    private readonly salesOrdersService: SalesOrdersApiService,
    private declinedReasonsService: DeclinedReasonService,
  ) {}

  getOrderLink(orderId: string, businessId: string): string {
    return `<a target="_blank" href="https://partners.vendasta.com${this.getOrderUrlPath(orderId, businessId)}">${orderId}</a>`;
  }

  getOrderUrlPath(orderId: string, businessId: string): string {
    return `/order-management/${businessId}/info/${orderId}`;
  }

  // There's no order getMulti because you need the business id as well. This does a list and converts the response to be
  // like a getMulti instead
  getMultiOrders(partnerId: string, orderIds: string[]): Observable<OrderInterface[]> {
    const allStatuses: Status[] = Object.values(Status)
      .filter((x) => typeof x === 'number')
      .map((x) => x as Status);
    return this.salesOrdersService
      .list(
        partnerId,
        new ListSalesOrderRequestFilters({
          orderIds: orderIds,
          statuses: allStatuses,
        }),
        null,
        '',
        orderIds.length > 0 ? orderIds.length : 1,
      )
      .pipe(
        take(1),
        map((resp) => {
          if (!(resp?.results?.length > 0)) {
            return [];
          }
          return orderIds.map((oId) => resp.results.find((o) => o.orderId === oId) || null);
        }),
      );
  }

  // getAllDeclinedReasons returns all the declined reasons for the partner, including the archived ones
  getAllDeclinedReasons(partnerId: string): Observable<DeclinedReason[]> {
    return this.declinedReasonsService.list(partnerId, { includeArchived: true }).pipe(shareReplay(1));
  }
}
